import {
  FETCH_SEARCH_SUCCESS,
  CLEAR_SEARCH,
  UPDATE_SEARCH,
  SET_HISTORY,
  SET_HISTORY_LOADED,
} from './types';

const fetchSearchSuccess = (state, { results }) => ({
  ...state,
  results,
});

const updateSearch = (state, { term }) => ({
  ...state,
  term,
  results: term ? state.results : [],
});

const clearSearch = state => ({
  ...state,
  term: '',
  results: [],
});

const setHistory = (state, { searchTermHistory }) => ({
  ...state,
  searchTermHistory: Array.isArray(searchTermHistory) ? searchTermHistory : [],
});

const setHistoryLoaded = state => ({
  ...state,
  searchHistoryLoaded: true,
});

const reducer = {
  [FETCH_SEARCH_SUCCESS]: fetchSearchSuccess,
  [CLEAR_SEARCH]: clearSearch,
  [UPDATE_SEARCH]: updateSearch,
  [SET_HISTORY]: setHistory,
  [SET_HISTORY_LOADED]: setHistoryLoaded,
};

const initialState = {
  term: '',
  results: [],
  searchTermHistory: [],
  searchHistoryLoaded: false,
};

export default (state = initialState, action) =>
  (action.type && reducer[action.type] ? reducer[action.type](state, action) : state);
